import { Team, TeamId } from '@/react/portainer/users/teams/types';

import { PortainerSelect } from '@@/form-components/PortainerSelect';

interface Props {
  name?: string;
  value: TeamId[] | readonly TeamId[];
  onChange(value: TeamId[]): void;
  teams: Team[];
  dataCy: string;
  inputId?: string;
  placeholder?: string;
  disabled?: boolean;
  isLoading?: boolean;
  /** Allow creating a new team by typing a name and pressing Enter. */
  isCreatable?: boolean;
  onCreateOption?: (name: string) => void;
}

export function TeamsSelector({
  name,
  value,
  onChange,
  teams,
  dataCy,
  inputId,
  placeholder,
  disabled,
  isLoading,
  isCreatable,
  onCreateOption,
}: Props) {
  const options = teams.map((team) => ({ label: team.Name, value: team.Id }));

  return (
    <PortainerSelect<number>
      name={name}
      isMulti
      options={options}
      value={value}
      onChange={(value) => onChange(value)}
      data-cy={dataCy}
      inputId={inputId}
      placeholder={placeholder}
      disabled={disabled}
      isLoading={isLoading}
      isCreatable={isCreatable}
      onCreateOption={onCreateOption}
      formatCreateLabel={
        isCreatable ? (input) => `Create team "${input}"` : undefined
      }
      noOptionsMessage={
        isCreatable
          ? () => 'Type a team name and press Enter to create it.'
          : undefined
      }
    />
  );
}
